import { Component, Inject } from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-connection-lost',
    templateUrl: './connection-lost.component.html',
    styles: [],
    standalone: false
})
export class ConnectionLostComponent {

  connectionLost: string;

  constructor(
    public dialogRef: MatDialogRef<ConnectionLostComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    public translate: TranslateService,
  ) {
    translate.get('GLOBAL.LOST-CONNECTION').subscribe((res) => {
      this.connectionLost = res;
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
